import { render, staticRenderFns } from "./BreadcrumbList.vue?vue&type=template&id=6a1e26c0&scoped=true&"
import script from "./BreadcrumbList.vue?vue&type=script&lang=ts&"
export * from "./BreadcrumbList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1e26c0",
  null
  
)

export default component.exports